import { apiSecond } from '@/boot/axios'
import i18n from '@/i18n'

export default {
	state: {
		pools: [],
		regions: [],
		districts: [],
		ponds: [],
		userPonds: [],
		plots: [],
		userPlots: [],
		reservoirTypes: [],
		orgType: [],
		fishes: [],
		fishCategories: [],
		fishStateTypes: [],
		fishPurposes: [],
		brigades: [],
		countries: [],
		waters: [],
		guns: [],
		roles: [],
		aquaSources: [],
	},
	getters: {
		_getDistricts(state) {
			return state.districts
		},
		_getFishes(state) {
			return state.fishes
		},
		_getFishCategories(state) {
			return state.fishCategories
		},
		_getFishStateTypesList(state) {
			return state.fishStateTypes
		},
		_getFishPurposes(state) {
			return state.fishPurposes
		},
		_getFishStateTypeById(state) {
			return (id) => {
				return state.fishStateTypes.find((el) => el.id === id)
			}
		},
		_getFishStateSubTypesList(state, getters) {
			return (id) => {
				return getters._getFishStateTypeById(id)?.subTypes || []
			}
		},
		_getFishStateSubTypeById(state, getters) {
			return (id, subId) => {
				return getters._getFishStateSubTypesList(id).find((el) => el.id === subId)
			}
		},
		_getRegionList(state) {
			return state.regions
		},
		_getCountryList(state) {
			return state.countries
		},
		_getPondList(state) {
			return state.ponds
		},
		_getPondById(state) {
			return (id) => {
				return state.ponds.find((p) => p.id === id)
			}
		},
		_getUserPondList(state) {
			return state.userPonds
		},
		_getWaterList(state) {
			return state.waters
		},
		_getPools(state) {
			return state.pools
		},
		_getGuns(state) {
			return state.guns
		},
		_getPlots(state) {
			return state.plots
		},
		_getRoles(state) {
			return state.roles
		},
		_getBrigades(state) {
			return state.brigades
		},
		_getReservoirTypes(state) {
			return state.reservoirTypes
		},
		_getOrgType(state) {
			return state.orgType
		},
		_getAquaSources(state) {
			return state.aquaSources
		},
	},
	mutations: {
		SET_DISTRICTS(state, payload) {
			state.districts = payload
		},
		SET_FISHES(state, payload) {
			state.fishes = payload
		},
		SET_FISH_CATEGORIES(state, payload) {
			state.fishCategories = payload
		},
		SET_FISH_STATE_TYPES_LIST(state, payload) {
			state.fishStateTypes = payload
		},
		SET_FISH_PURPOSES(state, payload) {
			state.fishPurposes = payload
		},
		SET_REGION_LIST(state, payload) {
			state.regions = payload
		},
		SET_COUNTRY_LIST(state, payload) {
			state.countries = payload
		},
		SET_POND_LIST(state, payload) {
			state.ponds = payload
		},
		SET_USER_POND_LIST(state, payload) {
			state.userPonds = payload
		},
		SET_WATER_LIST(state, payload) {
			state.waters = payload
		},
		SET_POOLS(state, payload) {
			state.pools = payload
		},
		SET_GUNS(state, payload) {
			state.guns = payload
		},
		SET_PLOTS(state, payload) {
			state.plots = payload
		},
		SET_USER_PLOT_LIST(state, payload) {
			state.userPlots = payload
		},
		SET_ROLES(state, payload) {
			state.roles = payload
		},
		SET_BRIGADES(state, payload) {
			state.brigades = payload
		},
		SET_RESERVOIR_TYPES(state, payload) {
			state.reservoirTypes = payload
		},
		SET_ORG_TYPE(state, payload) {
			state.orgType = payload
		},
		SET_AQUA_SOURCES(state, payload) {
			state.aquaSources = payload
		},
	},
	actions: {
		async _fetchDistricts({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-country-districts', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				commit(
					'SET_DISTRICTS',
					response.data.data.map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchFishes({ commit }) {
			try {
				const response = await apiSecond.get('/v2/handbook-fishes')
				commit(
					'SET_FISHES',
					response.data.data.map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchFishCategories({ commit }) {
			try {
				const response = await apiSecond.get('/v2/handbook-fish-categories')
				commit(
					'SET_FISH_CATEGORIES',
					response.data.data.map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchFishPurposes({ commit }) {
			try {
				const response = await apiSecond.get('/v2/handbook-purposes')
				commit('SET_FISH_PURPOSES', response.data.data)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchFishStateTypesList({ commit }) {
			try {
				const response = await apiSecond.get('v1/subject/list/9/types')
				commit('SET_FISH_STATE_TYPES_LIST', response.data.data)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchRegionList({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-regions', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				if (response.data && response.data.data)
					commit(
						'SET_REGION_LIST',
						response.data.data.map((element) => {
							element.name = element.title
							return element
						}),
					)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchCountryList({ commit }) {
			try {
				const response = await apiSecond.get('v1/catalog/14/entry/all')
				commit(
					'SET_COUNTRY_LIST',
					response.data.map((element) => {
						element.name = element.values[0].value
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchPondList({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-reservoirs', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				commit(
					'SET_POND_LIST',
					response.data.data.map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		// Водоёмы конкретного субъекта — те, на которые у него есть действующая квота.
		// Субъекту id можно передавать свой, бэкенд его игнорирует и отдаёт собственные водоёмы.
		async _fetchUserPondList({ commit }, userId = null) {
			if (!userId) {
				commit('SET_USER_POND_LIST', [])
				return
			}
			try {
				const response = await apiSecond.get(`/v1/user/${userId}/reservoirs`)
				commit(
					'SET_USER_POND_LIST',
					(Array.isArray(response.data) ? response.data : []).map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				commit('SET_USER_POND_LIST', [])
				console.log(err)
			}
		},
		// Участки конкретного субъекта — отдельного справочника нет, поэтому собираем
		// уникальные участки из его квот (без per_page бэкенд отдаёт все квоты целиком).
		async _fetchUserPlotList({ commit }, userId = null) {
			if (!userId) {
				commit('SET_USER_PLOT_LIST', [])
				return
			}
			try {
				const response = await apiSecond.get(`/v1/user/${userId}/quota`)
				const quotas = Array.isArray(response?.data?.data) ? response.data.data : []
				const titleField = i18n.locale === 'kz' ? 'title_kz' : 'title'
				const plots = new Map()
				quotas.forEach((quota) => {
					const plot = quota.plot
					if (!plot || plots.has(plot.id)) return
					plots.set(plot.id, {
						id: plot.id,
						title: plot[titleField] || plot.title,
						reservoir_id: plot.reservoir_id,
						reservoir: quota.reservoir || quota.pond || null,
					})
				})
				commit(
					'SET_USER_PLOT_LIST',
					[...plots.values()].sort((a, b) => String(a.title).localeCompare(String(b.title))),
				)
			} catch (err) {
				commit('SET_USER_PLOT_LIST', [])
				console.log(err)
			}
		},
		async _fetchWaterList({ commit }, id = 'all') {
			try {
				const response = await apiSecond.get(`v1/catalog/3/entry/${id}`)
				commit(
					'SET_WATER_LIST',
					response.data.values.map((element) => {
						element.name = element.value
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchPools({ commit }) {
			try {
				const response = await apiSecond.get('/v2/handbook-pools')
				commit(
					'SET_POOLS',
					response.data.data.map((element) => {
						element.name = element.title
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchGuns({ commit }) {
			try {
				const response = await apiSecond.get('/v2/handbook-fishing-gears')
				if (response.data && response.data.data)
					commit(
						'SET_GUNS',
						response.data.data.map((element) => {
							element.name = element.title
							return element
						}),
					)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchPlots({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-plots', {
					params: {
						page: 1,
						per_page: 100000,
						...filters,
					},
				})
				commit('SET_PLOTS', response.data.data)
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchRoles({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v1/user/role/list', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				commit(
					'SET_ROLES',
					response.data.map((element) => {
						element.title = element.description
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
		// Бригады субъекта. Субъект зовёт без параметров и получает свои,
		// остальным ролям user_id обязателен — иначе бэкенд ответит 422.
		async _fetchBrigades({ commit }, payload = null) {
			const userId = payload && typeof payload === 'object' ? payload.user_id : payload
			try {
				const response = await apiSecond.get('v2/brigade', {
					params: userId ? { user_id: userId } : {},
				})
				commit('SET_BRIGADES', (Array.isArray(response.data) ? response.data : []).reverse())
			} catch (error) {
				commit('SET_BRIGADES', [])
				console.log(error)
			}
		},
		async _fetchReservoirTypes({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-reservoir-types', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				commit('SET_RESERVOIR_TYPES', response?.data?.data || [])
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchOrgType({ commit }, filters = {}) {
			try {
				const response = await apiSecond.get('/v2/handbook-catch-types', {
					params: {
						page: 1,
						per_page: 10000,
						...filters,
					},
				})
				commit('SET_ORG_TYPE', response?.data?.data || [])
			} catch (err) {
				console.log(err)
			}
		},
		async _fetchAquaSources({ commit }) {
			try {
				const response = await apiSecond.get('/v2/water-supply-source')
				commit(
					'SET_AQUA_SOURCES',
					response.data.data.map((element) => {
						element.name = element.title
						element.name_eng = element.title_eng
						element.name_kaz = element.title_kaz
						return element
					}),
				)
			} catch (err) {
				console.log(err)
			}
		},
	},
}
